/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
// var esUtils = require('ES/utils/esUtils');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {sid: -1, has_tripit_connected: null, is_reading: false, read_error_msg: null};
  },
  componentWillReceiveProps: function (props) {
    this.__loadForSid(props.selected_sid);
  },
  componentDidMount: function () {
    this.__loadForSid(this.props.selected_sid);
  },
  __loadForSid: function (sid) {
    if (sid != this.state.sid) {
      this.setState({sid: sid, has_tripit_connected: null, is_reading: false, read_error_msg: null}, function () {
        radio('read_Thirdpartyconnection_TripIt_config').broadcast(sid);
      });
    }
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      read_Thirdpartyconnection_TripIt_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({has_tripit_connected: null, is_reading: true, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_TripIt_config_succeeded: function (sid, has_it) {
        if (self.state.sid == sid) {
          self.setState({has_tripit_connected: !!has_it, is_reading: false, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_TripIt_config_failed: function (sid, message) {
        if (self.state.sid == sid) {
          self.setState({has_tripit_connected: null, is_reading: false, read_error_msg: 'Failed to read your TripIt connector settings: ' + message});
        }
      }
    };
  },
  render: function () {
    var Displaylists = this.props.Displaylists;
    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
      return spkr.sid == this.state.sid;
    }, this);

    // var connect_url = '/balboa3/thirdpartyconnection/configtripit/' + this.state.sid + '/start_oauth?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);

    return dd.div(null,
      LoadingWrap({is_loading: this.state.is_reading, glass: true},
        dd.h3(null, 'TripIt connector for ',
          dd.span({className: 'nametag'},
            AuthedUserSession.MY_USERNAME),
          ' + ',
          dd.span({className: 'nametag'},
            speaker ? speaker.name_full : '')
        ),
        dd.p({className: 'text-muted'},
          'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ',
          'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'
        ),
        ErrorAlert({message: this.state.read_error_msg}),
        dd.div({className: 'alert alert-warning'},
          'TripIt has officially discontinued support for their API and do not allow third parties (like us) to pull your trip data.  We are sorry you can no longer sync your trips and we are exploring new options that can bring you the same great experience you have had.'
        )
        // this.state.has_tripit_connected === true ? dd.div(null,
        //   dd.div({className: 'alert alert-danger'},
        //     'You are connected to TripIt but will lose access in the coming days.'
        //   )
        // ) : dd.div(null,
        //   dd.p(null,
        //     'The link below will take you to TripIt\'s site, where you can log in to TripIt, and choose which of your TripIt accounts you want to link to ',
        //     '(if you have more than one TripIt account).'
        //   ),
        //   dd.p(null,
        //     'TripIt will ask if it\'s OK for eSpeakers to access your trips, and you should ', dd.b(null, 'choose ALLOW ACCESS')
        //   ),
        //   dd.br(),
        //   dd.br()
        // )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/TripIt.js